const doc = [({"en":({"js":({"layout":({"you_have_been_signed_out":"You have been signed out", "log_out":"Sign out", "you_were_signed_out":"You were signed out"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;